<template>
  <div
    class='period'
    :class="{
      'period-edit': isPermanent,
      'period-edit-permanent': permanentSet,
    }"
  >
    <read-period v-if='isPureText' :value='value' :dateFormat='dateFormat'></read-period>
    <template v-else>
      <el-date-picker
      class='sy-date-editor'
      v-bind="{ ...props }"
      clearable
      v-model="value.startTime"
      :placeholder="fieldPlaceholder[0]"
      :type="dateType"
      :format="dateFormat"
      :disabled="disabled"
      :picker-options="{
        disabledDate: disabledDate.bind(null, value.endTime, '>', dateType)
      }"
      :size="size"
      @change="handleChange"
    />
    <span class='item-separator'>{{ pageText.to }}</span>
    <el-date-picker
      class='sy-date-editor'
      v-bind="{ ...props }"
      v-model="value.endTime"
      :placeholder="fieldPlaceholder[1]"
      :type="dateType"
      :format="dateFormat"
      default-time="23:59:59"
      :disabled="disabled || (isPermanent && permanentSet && value.permanentSet)"
      :picker-options="{
        disabledDate: disabledDate.bind(null, value.startTime, '<', dateType)
      }"
      clearable
      :size="size"
      @change="handleChange"
    />
    <el-checkbox
      v-if="isPermanent && permanentSet"
      v-model="value.permanentSet"
      :disabled="disabled"
      @change="handlePermanentChange"
    >{{ pageText.forever }}
    </el-checkbox>
    </template>
  </div>
</template>

<script>
  import moment from 'moment'
  import ReadPeriod from './components/read-period.vue'
  import { periodProps } from './index.js'
  import i18n from './i18n.js'

  const pageText = window.fe.getPageText(i18n)

  export default {
    name: 'period',
    components: {
      ReadPeriod
    },
    props: periodProps,
    model: {
      prop: 'value',
      event: 'change'
    },
    data () {
      return {
        pageText,
        fieldPlaceholder: [pageText.startDate, pageText.endDate]
      }
    },
    watch: {
      value: {
        handler (val) {
          if (!val) {
            this.value = {
              startTime: '',
              endTime: '',
              permanentSet: false
            }
          }
          if (val && val.permanentSet) {
            this.value.endTime = ''
            this.fieldPlaceholder[1] = this.pageText.forever
          }
        },
        immediate: true
      }
    },
    computed: {
      dateType () {
        const config = {
          'yyyy-MM': 'month',
          'yyyy-MM-dd': 'date',
          'yyyy-MM-dd HH:mm': 'datetime',
          'yyyy-MM-dd HH:mm:ss': 'datetime'
        }
        if (config[this.dateFormat] === 'month') {
          this.fieldPlaceholder = [
            this.pageText.startMonth,
            this.value.permanentSet
              ? this.pageText.forever
              : this.pageText.endMonth
          ]
        }
        return config[this.dateFormat]
      }
    },
    methods: {
      handleChange () {
        if (this.value['startTime']) {
          this.value['startTime'] = moment(this.value['startTime']).format('YYYY-MM-DD HH:mm:ss')
        }
        if (this.value['endTime']) {
          this.value['endTime'] = moment(this.value['endTime']).format('YYYY-MM-DD HH:mm:ss')
        }
        this.$emit('change', this.value)
      },
      handlePermanentChange () {
        this.value.endTime = ''
        if (this.value.permanentSet) {
          this.$set(this.fieldPlaceholder, [1], this.pageText.forever)
        } else {
          this.$set(this.fieldPlaceholder, [1], this.pageText.endDate)
        }
        this.handleChange()
      },
      disabledDate (refer, action, type = 'timestamp', date) {
        if (!refer) {
          return false
        }
        if (this.dateType === 'datetime') {
          let newDate = refer
          newDate = new Date(newDate).setHours('00')
          newDate = new Date(newDate).setMinutes('00')
          newDate = new Date(newDate).setSeconds('00')
          refer = newDate
        }
        if (action === '>') {
          return new Date(date).getTime() > new Date(refer).getTime()
        } else if (action === '<') {
          return new Date(date).getTime() < new Date(refer).getTime()
        }
        return false
      }
    }
  }
</script>

<style scoped lang='scss'>
  .period {
    width: 230px;

    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: calc(50% - 13px);
    }
  }

  .period-edit {
    width: 100%;

    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: calc(50% - 13px);
    }
  }

  .period-edit-permanent {
    width: 100%;

    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: calc(50% - 40px);
    }
  }
</style>
